import Collaborators from './components/Collaborators';
import Users from './components/Users';

export const VIEWS = {
  users: (props) => <Users {...props} />,
  collaborators: (props) => <Collaborators {...props} />,
};
